exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.cancel-button{color:var(--text-dark);background-color:var(--white);border:1px solid var(--border)}button.cancel-button:hover:not(:disabled),button.cancel-button:focus:not(:disabled),button.cancel-button:active:not(:disabled){background-color:initial;border-color:var(--border)}button.cancel-button:active:not(:disabled){background-color:var(--aluminium-5)}", ""]);

// exports
